import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import EventCard from '../components/EventCard';
import { pastEvents, upcomingEvents } from '../data/events';

export default function EventsPage() {
  return (
    <Box>
      <Stack spacing={2} sx={{ mb: { xs: 4, md: 6 }, maxWidth: 720 }}>
        <Typography variant="overline" sx={{ letterSpacing: 4, color: 'primary.main' }}>
          Events
        </Typography>
        <Typography variant="h4">
          Gatherings that connect individual expertise with Mexico's most pressing challenges.
        </Typography>
        <Typography variant="body1" color="text.secondary">
          From civic forums to cultural exchanges, our calendar brings together leaders,
          innovators, and community partners to design solutions and celebrate progress.
        </Typography>
      </Stack>

      {upcomingEvents.length > 0 ? (
        <Box sx={{ mb: { xs: 6, md: 8 } }}>
          <Typography variant="h5" sx={{ mb: 1 }}>
            Upcoming experiences
          </Typography>
          <Divider sx={{ mb: 4 }} />
          {upcomingEvents.map((event) => (
            <EventCard key={event.id} {...event} />
          ))}
        </Box>
      ) : (
        <Box sx={{ mb: { xs: 6, md: 8 } }}>
          <Typography variant="h5" sx={{ mb: 1 }}>
            Upcoming experiences
          </Typography>
          <Divider sx={{ mb: 3 }} />
          <Typography variant="body1" color="text.secondary">
            We are confirming our next programs. Check back soon or follow us on social channels for
            announcements.
          </Typography>
        </Box>
      )}

      <Box>
        <Typography variant="h5" sx={{ mb: 1 }}>
          Recent highlights
        </Typography>
        <Divider sx={{ mb: 4 }} />
        {pastEvents.map((event) => (
          <EventCard key={event.id} {...event} />
        ))}
      </Box>
    </Box>
  );
}
